'use strict';

var Strings = require('utils/strings');
var Misc = require('utils/misc');
var Svg = require('utils/svg');
var i18n = require('utils/i18n');
var popoverContent = require('components/devices/templates/controller/popover_content');
var popoverOverlay = require('components/devices/templates/controller/popover_overlay');
var Decorator = require('utils/decoration');

// displays the timeprograms configured by the user
var TimeProgramView = Backbone.Marionette.ItemView.extend({
    template: require('components/devices/templates/controller/time_program'),

    ui: {
        svgContainer: '.svg-container',
        modal: '.modal-body',
        save: '#js-save',
        modeSelect: '#js-mode-select',
        time: '.js-dropdown-time',
        monday: '#js-timeline-0',
        tuesday: '#js-timeline-1',
        wednesday: '#js-timeline-2',
        thursday: '#js-timeline-3',
        friday: '#js-timeline-4',
        saturday: '#js-timeline-5',
        sunday: '#js-timeline-6',
        deletePopover: '#js-popover-overlay',
    },

    events: {
        'change @ui.time': 'setIntervalWidthViaDropdown',
        'mousedown @ui.svgContainer': 'eventDispatcher',
        'touchstart @ui.svgContainer': 'eventDispatcher',
        'mousedown @ui.deletePopover': 'eventDispatcher',
        'touchstart @ui.deletePopover': 'eventDispatcher',
        'click @ui.save': 'saveClicked',
        'change @ui.modeSelect': 'changeMode',
    },
    ID: 0, // generic counter which is used to enumerate the time-intervals
    hour: 100, // 100 svg-units corresponds to an hour

    initialize: function (options) {
        this.handleView = options.handleView;
        this.days = [
            this.ui.monday,
            this.ui.tuesday,
            this.ui.wednesday,
            this.ui.thursday,
            this.ui.friday,
            this.ui.saturday,
            this.ui.sunday,
        ];

        this.TimeProgramModel = $.extend(true, {}, options.timeProgramModel);

        // init the timelines and screen-parameters
        var view = this;
        $(document).one('shown.bs.modal', function (e) {
            e.data = view;
            view.updateScreenDependendParamters(e);
            view.TimeProgramModel.initialize(
                view.TimeProgramModel.name,
                view.TimeProgramModel.data,
                view.TimeProgramModel.timeProgramNumber,
                view.tableWidth
            );
            view.drawAllTimelines();
        });

        // create dropdowns for popover
        var hours = [];
        for (var i = 0; i < 25; i++) {
            hours.push({ display: Strings.twoDigitsLeadingZero(i), svg: i });
        }
        var time = {
            hours: hours,
            minutes: [
                { display: '00', svg: 0 },
                { display: '15', svg: 25 },
                { display: '30', svg: 50 },
                { display: '45', svg: 75 },
            ],
        };
        this.content = popoverContent(time);
        $(window).on('resize.modal-dialog', this, this.updateScreenDependendParamters);

        // cleanup all custom events when closing the modal
        $(document).one('hidden.bs.modal', function (e) {
            view.removeCustomEvents();
            $('.popover').remove();
        });
    },

    // provide configuration for the template
    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);
        data.labelsAndIDs = this.TimeProgramModel.TimeModeLabels[this.TimeProgramModel.mode];
        data.name = this.TimeProgramModel.name;
        return data;
    },

    onRender: function () {
        // redraw timlines and adapte to the current size
        this.ui.modeSelect.val(this.TimeProgramModel.mode);
        if ($(this.days[0])[0] !== undefined) {
            this.drawAllTimelines();
        }
        // don't update parameters if modal is not shown (e.g. when first starting)
        if ($('#js-modal-dialog').is(':visible')) {
            this.updateScreenDependendParamters({ data: this });
        }
    },

    updateScreenDependendParamters: function (e) {
        var view = e.data;
        if (view.ui.monday.offset) {
            // svgOffset = distance from the svg-coordinate-origin to the left screen-border
            view.svgOffset = view.ui.monday.offset().left;
        }
        var $popover = $('.popover');
        if ($popover.length > 0) {
            $('#js-popover-overlay').remove();
            var $timeline = $(
                '#js-timeline-' + view.getDayFromTarget({ target: $('#js-interval-' + $popover.attr('id'))[0] })
            );
            $popover.remove();
            view.unifyIntervals($timeline);
            view.removeSmallIntervals($timeline);
            view.removeTimeLabels();
            view.updateModel.call(view, $timeline);
        }
    },

    // returns an integer representing the day of the modified timeline
    getDayFromTarget: function (e) {
        var $target = $(e.target);
        if ($target.closest('[class^="js-timeline-"]').length > 0) {
            return $target.closest('[class^="js-timeline-"]').attr('class').split('-')[2];
        }
        return false;
    },

    // createing popover with time-dropdowns
    showPopover: function ($target, istouch) {
        // create a layer to sepparate the modal from the popover
        var $modal = $('#modal');
        var border = 2 * parseInt($modal.css('padding-bottom'));
        $modal.append(
            popoverOverlay({
                height: $modal.height() + border,
                width: $modal.width() + border,
                padding: border,
            })
        );

        var id = this.getElementID($target);
        this.editedInterval = $('#js-interval-' + id);
        // append popover to the interval
        $target.popover({
            trigger: 'manual',
            content: this.content,
            container: 'body',
            // the popover may only be placed inside the container.
            // container=body alows positioning outside of the modal
            placement: 'auto top',
            html: true,
            sanitizeFn: function (x) {
                // hack: bootstap removes dropdowns for security reasons which do not apply in our case
                return x;
            },
        });
        $('#js-overlay-' + id).popover('show');
        $('.popover').attr('id', id);
        $('.popover').addClass('timePickerWrapper');
        this.setDropdownTime(id);
        this.repositionPopover($('#' + id), $target);

        var view = this;
        $('.js-dropdown-time').on('change', function (e) {
            view.setIntervalWidthViaDropdown.call(view, e);
        });

        var $timeline = $('#js-timeline-' + view.getDayFromTarget({ target: view.editedInterval }));
        // popover can only be closed with an event of the device-type that opened it.
        var event = istouch ? 'touchstart' : 'mousedown';
        // delete interval and remove popover
        $('#js-delete-interval').one(event, function (e) {
            e.preventDefault();
            if (view.isfirefoxBugClick(view, e)) {
                return;
            }
            $('#js-popover-overlay').remove();
            view.updateModel.call(view, $timeline);
            $target.popover('destroy');
            view.removeInterval(id);
            view.updateModel.call(view, $timeline);
        });
        // save changes and remove popover
        $('#js-popover-overlay').one(event, function (e) {
            e.preventDefault();
            if (view.isfirefoxBugClick(view, e)) {
                return;
            }
            $('#js-popover-overlay').remove();
            $target.popover('destroy');
            view.unifyIntervals($timeline);
            view.removeSmallIntervals($timeline);
            view.removeTimeLabels();
            view.updateModel.call(view, $timeline);
        });
    },

    // If endHour is set to 24, leave 00 as only selectable minute-option
    restrictMinuteSelect: function (endHour, endMin) {
        var $endMinute = $('#js-end-minute');
        var isLastHour = endHour === 24;

        $endMinute.find('option[value=25]').attr('disabled', isLastHour);
        $endMinute.find('option[value=50]').attr('disabled', isLastHour);
        $endMinute.find('option[value=75]').attr('disabled', isLastHour);
        $endMinute.val(isLastHour ? 0 : endMin);
    },

    // sets the start-values of the select-elements in the active popover
    setDropdownTime: function () {
        // 100 svg-units= 1 hour
        var start = parseInt(this.editedInterval.attr('x'));
        var end = start + parseInt(this.editedInterval.attr('width'));
        var startHour = Math.floor(start / 100);
        var endHour = Math.floor(end / 100);
        var startMinute = start - startHour * 100;
        var endMinute = end - endHour * 100;
        this.restrictMinuteSelect(endHour, endMinute);

        // write values inside the select-elements
        $('#js-start-hour').val(startHour);
        $('#js-end-hour').val(endHour);
        $('#js-start-minute').val(startMinute);
    },

    // moves Popover to the left, if there is not enough space on the right
    // in order to prevent linebreaking (if the modal's width is big enough).
    repositionPopover: function ($popover, $target) {
        // for some reason, bootstrap's popover has difficulties to position itself in a modal
        // so we do it ourself.
        var topOffset = $('#js-interval-' + this.getElementID($target)).offset().top - 60;
        $popover.css('top', topOffset);

        // if the popover is not at the very right, than it's always displayed correctly
        if (parseInt($popover.css('right')) !== 0) {
            return;
        }

        // save the state of the Popover before modification
        var topOffset = parseInt($popover.css('top'));
        var arrowPosition = parseInt($popover.css('left')) + parseInt($('.arrow').css('left'));

        // The popover expands as necessary when moved to the left
        $popover.css('left', 0);

        // compute the new left- and top-offset
        var popoverWidth = $popover.width();
        var leftOffset = $('.modal-dialog').width() + $('.modal-dialog').offset().left - popoverWidth - 2;
        $popover.css('left', leftOffset);
        // reposition the arrow to its original place
        $('.arrow').css('left', arrowPosition - leftOffset);
    },

    // setIntervalWidthViaDropdown reads the time from the popover and previews the changes to be made
    // changes are saved on "deletePopover"
    setIntervalWidthViaDropdown: function (e) {
        // remove any error-class that was set beforehand
        $('.js-dropdown-time').removeClass('parsley-error');
        // read the start- and endtime of the new interval from the dropdowns
        var startHour = parseInt($('#js-start-hour').val());
        var startMinute = parseInt($('#js-start-minute').val());
        var endHour = parseInt($('#js-end-hour').val());
        var endMinute = parseInt($('#js-end-minute').val());
        this.restrictMinuteSelect(endHour, endMinute);
        // if the end time is BEFORE the start time, show an error on the used dropdown and return
        if (startHour > endHour) {
            $('#js-start-hour').addClass('parsley-error');
            $('#js-end-hour').addClass('parsley-error');
            return;
        }
        if (startHour + startMinute / 25 >= endHour + endMinute / 25) {
            $(e.target).addClass('parsley-error');
            return;
        }
        this.changeInterval(
            { data: { view: this, start: startHour * 100 + startMinute, ID: this.getElementID(this.editedInterval) } },
            endHour * 100 + endMinute
        );
    },

    changeMode: function (e) {
        this.TimeProgramModel.setMode(parseInt(this.ui.modeSelect.val()));
        this.render();
    },

    saveClicked: function () {
        // extract the data attribute out of the TimeProgramModel and write it to the model
        var newTimeProgram = $.extend(true, [], this.model.attributes.time_programs);
        for (var i = 0; i < 7; i++) {
            newTimeProgram[this.TimeProgramModel.timeProgramNumber].data[i] = Misc.bit2intArray(
                this.TimeProgramModel.data[i]
            );
        }
        Decorator.disableElement('.modal-dialog');
        this.handleView.saveModel(
            {
                time_programs: newTimeProgram,
                changedValue: 'timeProgram_' + this.TimeProgramModel.timeProgramNumber,
            },
            i18n.TR('Zeitprogramm wurde erfolgreich gespeichert'),
            i18n.TR('Zeitprogramm konnte nicht gespeichert werden.')
        );
    },

    // translates a pixel-value into svg-value. The svg-value is rounded to a multiple of a quater of an hour
    pixelToSVGUnit: function (pixel) {
        // svgOffset = padding+ margin etc. till we reach the svg
        // 2550 is the positive with of the svg-viewport
        var svgValue = (pixel - this.svgOffset) * (2550 / this.ui.svgContainer.width());
        // round to a quater of an hour
        return Math.round(svgValue * (4 / this.hour)) * (this.hour / 4);
    },

    getNextID: function () {
        this.ID = this.ID + 1;
        return this.ID;
    },

    getElementID: function ($target) {
        return $target.attr('id').split('-')[2];
    },

    // gets the svg- start- and endposition of the given Interval
    getBorders: function ($interval) {
        var start = parseInt($interval.attr('x'));
        return { start: start, end: start + parseInt($interval.attr('width')) };
    },

    unifyIntervals: function ($timeline) {
        var view = this;
        function overlap(day, $intervalA, $intervalB) {
            // unifies the given intervals if they overlap and returns true if so, false otherwise
            var bordersA = view.getBorders($intervalA);
            var bordersB = view.getBorders($intervalB);
            // either the start or the end of interval B must lie within interval A or the other way round
            if (bordersA.start <= bordersB.end && bordersB.start <= bordersA.end) {
                view.removeInterval(view.getElementID($intervalA));
                view.removeInterval(view.getElementID($intervalB));
                view.drawInterval(
                    view,
                    day,
                    Math.min(bordersB.start, bordersA.start),
                    Math.max(bordersA.end, bordersB.end)
                );
                return true;
            } else {
                return false;
            }
        }

        var intervals = [];
        var intervalsOverlap;
        var day = this.getElementID($timeline);
        for (var i = 0; i < $timeline.children('.interval').length - 1; i++) {
            // Important! intervals cannot be set outside of the loop, because $('.interval') may change between loop-iterations
            intervals = $timeline.children('.interval');
            for (var k = i + 1; k < intervals.length; k++) {
                if (overlap(day, $(intervals[i]), $(intervals[k]))) {
                    // if we unify two intervals, start the function again
                    this.unifyIntervals($timeline);
                    return;
                }
            }
        }
    },

    removeSmallIntervals: function ($timeline) {
        var view = this;
        $timeline.children('.interval').each(function () {
            if (parseInt(this.getAttribute('width')) < view.hour / 4) {
                var id = view.getElementID($(this));
                view.removeInterval(id);
            }
        });
    },

    eventDispatcher: function (e) {
        e.preventDefault();
        if (this.isfirefoxBugClick(this, e)) {
            return;
        }
        // detect if the user uses a mouse or a finger
        var motion = 'mousemove';
        var motionEnd = 'mouseup';
        if (e.type === 'touchstart') {
            motion = 'touchmove';
            motionEnd = 'touchend';
        }

        // collecting data for the function which is going to be executed
        var moveFunction = undefined;
        var endFunction = undefined;
        var data = {};
        data.view = this;
        data.start = this.pixelToSVGUnit(Misc.getCoordinates(e).x);
        data.day = this.getDayFromTarget(e);
        // user clicked outside of the svg, do nothing
        if (data.day === false) {
            return;
        }
        var isInterval;
        if ($(e.target).attr('class')) {
            isInterval = $(e.target).attr('class').includes('interval-overlay');
        } else {
            isInterval = $(e.target).hasClass('interval-overlay');
        }

        if (isInterval) {
            this.start = undefined;
            data.ID = parseInt(this.getElementID($(e.target)));
            data.interval = $('#js-interval-' + data.ID);
            data.intvStart = parseInt(data.interval.attr('x'));
            data.intvEnd = data.intvStart + parseInt(data.interval.attr('width'));
            moveFunction = this.moveBorder;
        } else {
            // draw an interval of width 0 if there aren't already 3 intervals
            if (!this.drawInterval(data.view, data.day, data.start, data.start)) {
                return;
            }
            data.ID = this.ID;
            moveFunction = this.changeInterval;
        }
        // dispatch the event to the right function

        $(document).on(motion, data, moveFunction);

        data.target = $(e.target);
        // remove eventhandler when the action is over (mouseup/touchend)
        $(document).one(motionEnd, data, function (e) {
            var view = data.view;
            // if mouse was not moved, show popover
            if (view.pixelToSVGUnit(Misc.getCoordinates(e).x) === e.data.start) {
                if (isInterval && parseInt(e.data.interval.attr('width')) != 0) {
                    view.showPopover(e.data.target, e.type.includes('touch'));
                } else if (!isInterval) {
                    // remove interval with width 0
                    view.removeInterval(view.ID);
                    var start = Math.min(e.data.start, 2300);
                    view.drawInterval(view, data.day, start, start + view.hour);
                }
            }
            $(document).off('mousemove touchmove', moveFunction);
            var $timeline = $('#js-timeline-' + data.day);
            view.unifyIntervals($timeline);
            view.removeSmallIntervals($timeline);
            view.removeTimeLabels();
            view.updateModel.call(view, $timeline);
        });
    },

    // modifies an existing interval and it's overlay. If the end parameter is given, it's used for
    // the interval's end, otherwise it's taken from the given event
    changeInterval: function (e, end) {
        var view = e.data.view;
        // position where touchstart/mousedown occured
        var down = e.data.start;
        // position where touchend/mouseup occured
        var up = end || view.pixelToSVGUnit(Misc.getCoordinates(e).x);
        var start = Math.max(Math.min(up, down), 0);
        var width = Math.min(Math.max(up, down) - start, 2400 - start);
        var interval = $('#js-interval-' + e.data.ID)[0];
        var touchOverlay = $('#js-overlay-' + e.data.ID)[0];
        interval.setAttribute('x', start);
        interval.setAttribute('width', width);
        touchOverlay.setAttribute('x', start - 50);
        touchOverlay.setAttribute('width', width + 100);
        if (!end) {
            // labels are only shown on drag
            $('#start').text(view.posToTime(start));
            $('#end').text(view.posToTime(start + width));
            $('#start')[0].setAttribute('x', start - 80);
            $('#end')[0].setAttribute('x', start + width - 80);
        }
    },

    // takes a position on the svg-scale between 0 and 2400 and returns the corresponding time
    // (800 ->08:00)
    // (2350->23:30)
    // (1275->12:45)
    posToTime: function (number) {
        var hour = Math.floor(number / 100);
        var quarter = ((number * 3) / 5) % 60;
        return Misc.leadingZero(hour) + ':' + Misc.leadingZero(quarter);
    },

    distance: function (x, y) {
        return Math.abs(x - y);
    },

    moveBorder: function (e) {
        var view = e.data.view;
        var selectedLabels = $('#js-labels-' + e.data.day)[0];
        var pointerPos = view.pixelToSVGUnit(Misc.getCoordinates(e).x);
        if (view.start === undefined) {
            // determine which of the intervals' borders is the one to be moved
            if (
                view.distance(e.data.intvStart, pointerPos) < view.distance(pointerPos, e.data.intvEnd) &&
                view.distance(e.data.intvStart, pointerPos) < view.hour
            ) {
                // mouse/finger was closer to the start of the interval
                view.start = e.data.intvEnd;
            } else if (
                view.distance(e.data.intvStart, pointerPos) >= view.distance(pointerPos, e.data.intvEnd) &&
                view.distance(pointerPos, e.data.intvEnd) < view.hour
            ) {
                // mouse/finger was closer to the end of the interval
                view.start = e.data.intvStart;
            }
            view.removeTimeLabels();
            view.drawTimeLabels(view, selectedLabels, e.data.intvStart, e.data.intvEnd);
        } else {
            e.data.start = view.start;
            view.changeInterval(e);
        }
    },

    // draws all timelines belonging to the current mode
    drawAllTimelines: function () {
        switch (this.TimeProgramModel.mode) {
            case 1:
                this.drawTimeline(this.TimeProgramModel.Days.Monday);
                this.removeTimeLabels();
                return;
            case 2:
                this.drawTimeline(this.TimeProgramModel.Days.Monday);
                this.drawTimeline(this.TimeProgramModel.Days.Saturday);
                this.removeTimeLabels();
                return;
            case 3:
                for (var i = 0; i < 7; i++) {
                    this.drawTimeline(i);
                }
                this.removeTimeLabels();
        }
    },

    drawTimeline: function (day) {
        var timeLineData = this.TimeProgramModel.data[day];
        var previousValue = 0;
        var locIndex = 0;
        for (var globIndex = 0; globIndex < 96; ) {
            while (timeLineData[locIndex] === previousValue) {
                locIndex++;
            }
            if (previousValue) {
                this.drawInterval(this, day, globIndex * 25, locIndex * 25);
            }
            previousValue = (previousValue + 1) % 2;
            globIndex = locIndex;
        }
    },

    drawInterval: function (view, day, start, end) {
        var selectedTimeline = $(view.days[day]);
        if (selectedTimeline.children('.interval').length >= 3) {
            return false;
        }
        // restrict start and end to the timespan [0 - 24]
        start = Math.max(0, start);
        end = Math.min(2400, end);
        var ID = view.getNextID();
        // drawing the actual time-interval
        Svg.drawRectangle(selectedTimeline[0], {
            style: 'opacity: 0.7',
            id: 'js-interval-' + ID,
            class: 'interval fill-custom',
            x: start,
            y: 50,
            width: end - start,
            height: 100,
        });

        // draw an overlay interval to enlarge touch-area
        Svg.drawRectangle(selectedTimeline[0], {
            fill: 'white',
            class: ID + ' interval-overlay',
            id: 'js-overlay-' + ID,
            style: 'opacity: 0',
            x: start - 50,
            y: -50,
            width: end - start + 100,
            height: 300,
        });

        view.drawTimeLabels(view, $('#js-labels-' + day)[0], start, end);
        return true;
    },

    drawTimeLabels: function (view, svg, start, end) {
        Svg.drawText(svg, view.posToTime(start), {
            'font-size': 80,
            x: start - 80,
            y: 60,
            id: 'start',
            class: 'svg-time-label',
        });
        Svg.drawText(svg, view.posToTime(end), {
            'font-size': 80,
            x: end - 80,
            y: 60,
            id: 'end',
            class: 'svg-time-label',
        });
    },

    removeTimeLabels: function () {
        $('.svg-time-label').remove();
    },

    removeInterval: function (id) {
        $('#js-interval-' + id).remove();
        $('#js-overlay-' + id).remove();
    },

    // converts the current state of the grafic to a timemodel
    updateModel: function ($timeline) {
        // loop over the days
        var intervals = [];
        var borders = {};
        var view = this;
        $timeline.children('.interval').each(function (index) {
            borders = view.getBorders($(this));
            intervals[index] = { start: borders.start / 25, end: borders.end / 25 };
        });
        this.TimeProgramModel.setIntervals(parseInt(this.getElementID($timeline)), intervals);
    },

    // cleans up all manual events
    removeCustomEvents: function () {
        $(window).off('resize.modal-dialog', this.updateScreenDependendParamters);
    },

    isfirefoxBugClick: function (view, e) {
        // workaround for firefox-bug 819102 which triggers mouse-events on touch - even with preventDefault
        // see https://bugzilla.mozilla.org/show_bug.cgi?id=819102
        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            // Do Firefox-related activities
            var newCoordinates = Misc.getCoordinates(e);
            if (
                view.lastEvent &&
                view.lastEvent.includes('touch') &&
                e.type.includes('mouse') &&
                newCoordinates.x == view.lastCoordinates.x &&
                newCoordinates.y == view.lastCoordinates.y
            ) {
                return true;
            }
            view.lastEvent = e.type;
            view.lastCoordinates = Misc.getCoordinates(e);
        }
        return false;
    },
});

module.exports = TimeProgramView;
